import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Accordion } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import MultipleFormBoxComp from "../../components/FormBox/MultipleFormBoxComp";
import { NewChequePaymentFormSchemaOptions } from "../../Utils/formOptions";
import { useAbortController } from "../../hooks/useAbortController";
import useBorowerLoanDetail from "../../hooks/useBorowerLoanDetail";
import urls from "../../Utils/urls";
import {
  handleRoutingDetails,
  setSameDayPayment,
} from "../../store/reducers/achPaymentSlice";
import { RoutingNumberValidator } from "../Borrowers/Pages/ACHPayments/SameDayPayment";
import AddAccountModal from "../Borrowers/Pages/ACHPayments/AddAccountModal";
import DeleteAccountModaal from "../Borrowers/Pages/ACHPayments/DeleteAccountModal";
import { loadingTypes } from "../../Utils/constant";
import { BlurWrapperWithSpan, SpinnerBlock } from "../../Utils/CustomComponent";

import useAchData from "../Borrowers/BankAccountACHPayments/useAchData";
import {
  TaxFormModal,
  TaxInfoModal,
} from "../Borrowers/BorrowerDashboard/AchPopup";
import { SelectAccount } from "../../components/Navbar";
import { fetchBorrowerAllLoansBankDetails } from "../../store/reducers/dashboardSlice/api";
import {
  ArrowLeft,
  ExclamationTriangle,
  Person,
  FileEarmark,
  Calendar,
  CurrencyDollar,
  CreditCard,
} from "react-bootstrap-icons";
import useBorrowerDashboardTwo from "../Borrowers/BorrowerDashboardTwo/apis/useBorrowerDashboardTwo";
import axios from "../../axios";

const NewSameDayPayment = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [achInfo, setAchInfo] = useState({});
  const [routingDetails, setRoutingDetails] = useState({});
  const [disableBtn, setDisableBtn] = useState(false);
  const [isRoutingNumberVerified, setIsRoutingNumberVerified] = useState(false);
  const [showRoutingNumberVaildatorPopup, setShowRoutingNumberVaildatorPopup] =
    useState(false);
  const [showAccountForm, setShowAccountForm] = useState(false);
  const [showDeleteForm, setShowDeleteForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showTaxForm, setShowTaxForm] = useState(false);
  const [showTaxInfo, setShowTaxInfo] = useState(false);

  const accountId = useSelector((state) => state.account.lenderId);
  const { loanDetails, status } = useBorowerLoanDetail(accountId);
  // const { bankDetails: paymentAccounts, status: optionStatus } =
  //   useBankDetails(accountId);
  const { activeAccountList } = useBorrowerDashboardTwo();
  const paymentAccounts = useSelector(
    (state) => state.dashboard.borrowerAllLoansBankAccounts.data,
  );
  const optionStatus = useSelector(
    (state) => state.dashboard.borrowerAllLoansBankAccounts.status,
  );
  const { fetchACHData, achData, loading: taxInfoLoading } = useAchData();

  const [selectedPaymentAccount, setSelectedPaymentAccount] = useState(
    null,
    // paymentAccounts?.options ? paymentAccounts.options[0] : null
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    setError,
    clearErrors,
    control,
    formState: { errors },
  } = useForm(NewChequePaymentFormSchemaOptions);
  const { signal } = useAbortController();
  // const location = useLocation();
  const { isLargeDevice } = useSelector((state) => state.RS_Sidebar);
  const location = useLocation();
  const nsfData = location.state?.nsfData;

  // Extract NSF data for display
  const borrowerName = nsfData?.borrower || "Borrower";
  const loanNumber = nsfData?.loanNumber || "N/A";
  // const failedAmount = nsfData?.amount;
  const failedAmount = nsfData?.isChecked
    ? nsfData?.numberAmountIncludingNSFFee
    : Math.abs(nsfData?.Amount);
  const maskedAccount = nsfData?.BankNumber
    ? `****${String(nsfData.BankNumber).slice(-4)}`
    : "N/A";
  const failureDate = nsfData?.dateFormatted || "N/A";
  const nsfFee =
    typeof nsfData?.nsfFee === "number" && nsfData?.nsfFee > 0
      ? nsfData.nsfFee
      : 45;

  const routingNumber = watch("routingNumber");
  const accountNumber = watch("accountNumber");
  const paymentType = watch("paymentType");
  // const verifyAccountNumber = watch("verifyAccountNumber");

  const accountIds = activeAccountList?.map((data) => data.value);
  const userId = localStorage.getItem("apex_userid");
  const options = paymentAccounts?.options || [];
  const clonedOptions = [...options];

  clonedOptions?.unshift({
    label: "+ Add New",
    value: "Add New",
  });
  clonedOptions?.unshift({
    label: "Select Value",
    value: "Select Value",
  });

  useEffect(() => {
    if (accountId) {
      fetchACHData(accountId);
      setValue("loan_account", loanNumber);
    }
  }, [accountId]);

  useEffect(() => {
    setValue("paymentType", "NSF");
  }, []);

  useEffect(() => {
    if (accountIds?.length) {
      dispatch(
        fetchBorrowerAllLoansBankDetails({
          requestBody: {
            RecID: accountIds.join(","),
          },
          userId,
          signal,
        }),
      );
    }
  }, [accountIds?.length]);

  useEffect(() => {
    if (achData?.length) {
      const show = achData[0].DISABLE_YN.toLowerCase() === "y" ? true : false;

      setShowTaxForm(show);
    }
  }, [achData?.length]);

  useEffect(() => {
    const handleRoutingNumberValidation = async () => {
      try {
        setDisableBtn(true);
        const getData = await axios.get(
          urls.borrower.getRoutingNumberValidation(routingNumber),
          { signal },
        );

        if (getData?.data.code == 404) {
          setError("routingNumber", {
            type: "custom",
            message: "Invalid routing number",
          });
          setShowRoutingNumberVaildatorPopup(true);
          setIsRoutingNumberVerified(false);
          setRoutingDetails({});
          dispatch(handleRoutingDetails({}));
          // setDisableBtn(true);
        } else if (getData?.data.code == 200) {
          setIsRoutingNumberVerified(true);
          setRoutingDetails(getData.data);
          dispatch(handleRoutingDetails(getData.data));
          setDisableBtn(false);
          clearErrors("routingNumber");
        }
        return getData.data;
      } catch (error) {
        setError("routingNumber", {
          type: "custom",
          message: "Routing validation failed",
        });
        setRoutingDetails({});
        dispatch(handleRoutingDetails({}));
        setShowRoutingNumberVaildatorPopup(true);
        setIsRoutingNumberVerified(false);
        // setDisabled(true);
      }
    };
    if (routingNumber?.length === 9) {
      handleRoutingNumberValidation();
    } else if (routingNumber?.length && routingNumber?.length !== 9) {
      setError("routingNumber", {
        type: "custom",
        message: "Routing number must be 9 digits",
      });
      setRoutingDetails({});
      dispatch(handleRoutingDetails({}));
      setDisableBtn(true);
    }
  }, [routingNumber]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get(
        urls.borrower.getPaymentsLoanAchSameDayInfo(accountId),
        { signal },
      );

      let data = res.data[0][0];
      setAchInfo(data);
      // setValue("bankAccountName", data?.ACH_IndividualName);
      setValue("payTo", "Superior Loan Servicing");
      setValue("amount", `${failedAmount}`);
      // setValue("routingNumber", data?.ACH_RoutingNumber);
      // setValue("accountNumber", data?.ACH_AccountNumber);
      // setValue("verifyAccountNumber", data?.ACH_AccountNumber);
    };
    fetchData();
  }, [accountId, setValue, failedAmount]);

  useEffect(() => {
    if (optionStatus === loadingTypes.fulfilled) {
      if (selectedPaymentAccount) {
        setValue("bankAccountName", selectedPaymentAccount?.ACH_INDIVIDUALNAME);
        setValue("routingNumber", selectedPaymentAccount?.routing_number);
        setValue("accountNumber", selectedPaymentAccount?.account_number);
        // setValue("verifyAccountNumber", selectedPaymentAccount?.account_number);
      } else {
        // setValue(
        //   "bankAccountName",
        //   paymentAccounts?.data?.[0]?.ACH_INDIVIDUALNAME
        // );
        // setValue("routingNumber", paymentAccounts?.data?.[0]?.routing_number);
        // setValue("accountNumber", paymentAccounts?.data?.[0]?.account_number);
        // setValue(
        //   "verifyAccountNumber",
        //   paymentAccounts?.data?.[0]?.account_number
        // );
      }
    } else if (optionStatus === loadingTypes.loading) {
      setSelectedPaymentAccount(null);
    }
  }, [selectedPaymentAccount, optionStatus]);

  useEffect(() => {
    setValue("memo", paymentType);
  }, [paymentType, setValue]);
  console.log(errors);
  const onSubmit = (data) => {
    // console.log(data);
    // if (accountNumber && verifyAccountNumber) {
    // if (accountNumber !== verifyAccountNumber) {
    //   setError("verifyAccountNumber", {
    //     type: "custom",
    //     message: "Account numbers do not match",
    //   });
    // } else {
    data.isRoutingNumberVerified = isRoutingNumberVerified;
    dispatch(
      setSameDayPayment({
        ...data,
        // amount: `${Math.abs(data?.amount)}`,
        loan_account_number: achInfo?.loan_account_number,
        bankName: routingDetails.customer_name,
        bankAddress: routingDetails.address,
        bankCity: routingDetails.city,
        bankState: routingDetails.state,
        bankZip: routingDetails.zip,
        bankTelephone: routingDetails.telephone,
      }),
    );
    setShowPopup(true);
    navigate("/preview-check");
    // }
    // }
  };

  function handleAccountChange(e) {
    setLoading(true);
    setSelectedPaymentAccount(e);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 600);

    return () => clearTimeout(timer);
  }

  const styles = {
    container: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "20px",
    },
    th: {
      textAlign: "left",
      backgroundColor: "#f0f0f0",
      padding: "10px",
      border: "1px solid black",
    },
    td: {
      padding: "10px",
      border: "1px solid black",
    },
  };
  const infoBoxStyle = {
    margin: "0.5em",
    padding: "0.5em",
    background: "#E5E5E5",
    fontSize: "1.4rem",
    lineHeight: "1.4",
    borderRadius: "8px",
  };

  if (!nsfData) {
    return <Navigate to="/nsf" replace />;
  }

  return (
    <div style={{ overflowY: "scroll" }}>
      {!taxInfoLoading ? (
        <section
          className=" rounded"
          style={{ background: "#eeeeee", minHeight: "100vh" }}
        >
          {/* <div className="p-3 pb-0  mt-1">
            <CustomBreadCrumbs
              crumbs={[
                { title: "Dashboard", link: "/borrower-dashboard-two" },
                { title: "Same Day Payment" },
              ]}
            />
          </div> */}
          <article className="container-fluid">
            <div className="p-5 pb-0  mt-1">
              <span
                className="linkClick"
                role="button"
                onClick={() => navigate(-2)}
              >
                <ArrowLeft size={20} /> Back
              </span>{" "}
              / <span>Same Day Payment</span>
            </div>
          </article>
          {status === loadingTypes.fulfilled ? (
            <article className="container-fluid py-5 rounded">
              <section className="bg-white p-5 my-2 mx-4">
                <div className="row"></div>
                <h4 className="mt-5">Same Day Payment Form</h4>

                <form>
                  <div className="loans-in-details mt-5">
                    <Accordion
                      defaultActiveKey="0"
                      className="border border-primary"
                    >
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>
                          <h5>
                            Check Requests Cut Off Time: 3:00 PM Pacific Time
                            (Any requests received after 3:00 PM will be
                            processed the next business day.)
                          </h5>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div style={infoBoxStyle} className="text-error">
                            There is a charge of $30 for this service. If you
                            don't need a same day payment, you can choose a next
                            day One Time Payment instead. “Same Day Payments”
                            must be received by 3PM (PT) on each business day
                            (excludes holidays). <br />
                            Please review your submission carefully, especially
                            the routing and account numbers on the check image.
                            Submission isn’t complete until you sign and press
                            "Submit" on the next page. A confirmation email will
                            follow.
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>

                    {/* NSF Details Section */}
                    {nsfData && (
                      <section className="bg-white p-4 my-2 mx-4 mb-4">
                        {/* Payment Details Section */}
                        <div className="nsf-payment-details">
                          <h5 className="nsf-section-title">
                            NSF Case Information
                          </h5>

                          <div className="nsf-payment-grid">
                            <div className="nsf-payment-item">
                              <div className="nsf-payment-icon nsf-payment-icon-blue">
                                <Person size={20} />
                              </div>
                              <div className="nsf-payment-info">
                                <div className="nsf-payment-label">
                                  Borrower Name
                                </div>
                                <div className="nsf-payment-value">
                                  {borrowerName}
                                </div>
                              </div>
                            </div>

                            <div className="nsf-payment-item">
                              <div className="nsf-payment-icon nsf-payment-icon-blue">
                                <FileEarmark size={20} />
                              </div>
                              <div className="nsf-payment-info">
                                <div className="nsf-payment-label">
                                  Loan Number
                                </div>
                                <div className="nsf-payment-value">
                                  {loanNumber}
                                </div>
                              </div>
                            </div>

                            <div className="nsf-payment-item">
                              <div className="nsf-payment-icon nsf-payment-icon-red">
                                <Calendar size={20} />
                              </div>
                              <div className="nsf-payment-info">
                                <div className="nsf-payment-label">
                                  NSF Date (Non-Sufficient Funds)
                                </div>
                                <div className="nsf-payment-value">
                                  {failureDate}
                                </div>
                              </div>
                            </div>

                            <div className="nsf-payment-item">
                              <div className="nsf-payment-icon nsf-payment-icon-green">
                                <CurrencyDollar size={20} />
                              </div>
                              <div className="nsf-payment-info">
                                <div className="nsf-payment-label">
                                  NSF Payment Amount
                                </div>
                                <div className="nsf-payment-value">
                                  {failedAmount !== null ? failedAmount : "N/A"}
                                </div>
                              </div>
                            </div>

                            <div className="nsf-payment-item">
                              <div className="nsf-payment-icon nsf-payment-icon-gray">
                                <CreditCard size={20} />
                              </div>
                              <div className="nsf-payment-info">
                                <div className="nsf-payment-label">
                                  Account Used
                                </div>
                                <div className="nsf-payment-value">
                                  {maskedAccount}
                                </div>
                              </div>
                            </div>

                            <div className="nsf-payment-item">
                              <div className="nsf-payment-icon nsf-payment-icon-warning">
                                <ExclamationTriangle size={20} />
                              </div>
                              <div className="nsf-payment-info">
                                <div className="nsf-payment-label">NSF Fee</div>
                                <div className="nsf-payment-value nsf-fee-value">
                                  ${nsfFee}
                                </div>
                              </div>
                            </div>

                            {nsfData?.LateCharges ? (
                              <div className="nsf-payment-item">
                                <div className="nsf-payment-icon nsf-payment-icon-warning">
                                  <ExclamationTriangle size={20} />
                                </div>
                                <div className="nsf-payment-info">
                                  <div className="nsf-payment-label">
                                    Late Charges
                                  </div>
                                  <div className="nsf-payment-value nsf-fee-value">
                                    ${nsfData?.LateCharges}
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </section>
                    )}

                    <table style={styles.container}>
                      <tr>
                        <th style={styles.th} className="bg-primary text-white">
                          Management Company Name:
                        </th>
                        <td style={styles.td}>Superior Loan Servicing</td>
                        <th style={styles.th} className="bg-primary text-white">
                          Loan Number:
                        </th>
                        <BlurWrapperWithSpan>
                          <td style={styles.td}>
                            {achInfo?.loan_account_number}
                          </td>
                        </BlurWrapperWithSpan>
                      </tr>
                      <tr>
                        <th style={styles.th} className="bg-primary text-white">
                          Phone Cell:
                        </th>
                        <td style={styles.td}>
                          {achInfo?.phonecell ? achInfo.phonecell : "-"}
                        </td>
                        <th style={styles.th} className="bg-primary text-white">
                          Phone Work:
                        </th>
                        <td style={styles.td}>
                          {achInfo?.phonework ? achInfo?.phonework : "-"}
                        </td>
                      </tr>
                      <tr>
                        <th style={styles.th} className="bg-primary text-white">
                          Pay To:
                        </th>
                        <td style={styles.td} colSpan="3">
                          Superior Loan Servicing
                        </td>
                      </tr>
                      <tr>
                        <th style={styles.th} className="bg-primary text-white">
                          Property Address:
                        </th>
                        <td style={styles.td} colSpan="3">
                          {
                            loanDetails?.loanTerm?.loanheader2?.split?.(
                              ":",
                            )?.[1]
                          }
                        </td>
                      </tr>
                    </table>

                    <div className=" p-5 mt-5 row">
                      {/* <div className="w-50 col-6">
                        <label htmlFor="loans" className="fw-bold">
                          Choose Loan Account:
                        </label>
                        <SelectAccount
                          id="loans"
                          isABorrower={true}
                          selectedRoleName={"Borrower"}
                          showOnlyActive={true}
                        />
                      </div> */}
                      <div className="col-6">
                        <label htmlFor="accounts" className="fw-bold">
                          Choose Bank Account:
                        </label>
                        {optionStatus === loadingTypes.fulfilled ? (
                          <div className="w-100 my-3">
                            <Select
                              id="accounts"
                              // options={paymentAccounts?.options}
                              options={clonedOptions}
                              // value={selectedPaymentAccount}
                              defaultValue={clonedOptions?.[0]}
                              onChange={handleAccountChange}
                              classNamePrefix="select"
                              theme={(theme) => ({
                                ...theme,
                                borderRadius: 0,
                                colors: {
                                  ...theme.colors,
                                  primary: "#ef8860",
                                },
                              })}
                            />
                          </div>
                        ) : optionStatus === loadingTypes.loading ? (
                          <div style={{ margin: "2rem" }}>
                            <SpinnerBlock height="50vh" />
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {optionStatus === loadingTypes.fulfilled && !loading ? (
                      sameDayPaymentArr(
                        achInfo?.loan_account_number,
                        loanDetails?.loanTerm?.loanheader2?.split?.(":")?.[1],
                        control,
                        selectedPaymentAccount,
                        paymentType,
                        nsfData?.isChecked,
                      )?.map((data, index) => {
                        return (
                          <MultipleFormBoxComp
                            key={index}
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            options={data.arr}
                            errors={errors}
                          />
                        );
                      })
                    ) : optionStatus === loadingTypes.loading || loading ? (
                      <div>
                        <SpinnerBlock height="2vh" />
                      </div>
                    ) : null}

                    <div className="text-center">
                      <button
                        type="button"
                        className="mt-5 btn btn-secondary border me-5"
                        style={{ width: "fit-content" }}
                        onClick={() => navigate(-2)}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="mt-5 btn btn-primary"
                        style={{ width: "fit-content" }}
                        disabled={disableBtn}
                        onClick={handleSubmit(onSubmit)}
                      >
                        Preview
                      </button>
                    </div>
                  </div>
                </form>
              </section>
            </article>
          ) : status === loadingTypes.loading ? (
            <div style={{ paddingTop: "8rem" }}>
              <SpinnerBlock height="50vh" />
            </div>
          ) : status === loadingTypes.error ? (
            <div>Some error occured</div>
          ) : null}
        </section>
      ) : (
        <div style={{ marginTop: "10rem" }}>
          <SpinnerBlock height="50vh" />
        </div>
      )}
      <RoutingNumberValidator
        show={showRoutingNumberVaildatorPopup}
        setShow={setShowRoutingNumberVaildatorPopup}
        clearErrors={clearErrors}
        setDisableBtn={setDisableBtn}
        routingNumber={routingNumber}
      />

      <AddAccountModal show={showAccountForm} setShow={setShowAccountForm} />
      <DeleteAccountModaal
        show={showDeleteForm}
        setShow={setShowDeleteForm}
        AccountSelect={
          <Select
            options={paymentAccounts}
            value={selectedPaymentAccount}
            onChange={handleAccountChange}
            classNamePrefix="select"
          />
        }
        selectedPaymentAccount={selectedPaymentAccount}
      />

      <TaxFormModal
        show={showTaxForm}
        setShow={setShowTaxForm}
        setShowTaxInfo={setShowTaxInfo}
      />

      <TaxInfoModal
        show={showTaxInfo}
        setShow={setShowTaxInfo}
        achCondition={false}
      />
      <style>
        {`
          .accordion-button:not(.collapsed) {
            pointer-events: none;
            cursor: default;
            color: #fff; 
            background-color: var(--primary-color);
}
        `}
      </style>
    </div>
  );
};

export default NewSameDayPayment;

const sameDayPaymentArr = (
  loanNumber,
  propertyAddress,
  control,
  selectedPaymentAccount,
  paymentType,
  isChecked,
) => {
  return [
    {
      field: "",
      arr: [
        {
          section: "",
          arr: [
            {
              title: "Bank Account Number",
              field: "accountNumber",
              type: "number",
              className: "col-6",
              disablePaste: true,
              // eyeIcon: true,
              disable:
                selectedPaymentAccount === null ||
                selectedPaymentAccount?.value === "Add New"
                  ? false
                  : true,
            },
            {
              title: "Name on Bank Account",
              field: "bankAccountName",
              type: "text",
              className: "col-6",
              disable:
                selectedPaymentAccount === null ||
                selectedPaymentAccount?.value === "Add New"
                  ? false
                  : true,
            },
            {
              title: "Check Amount",
              field: "amount",
              type: "amount",
              placeholder: "Enter amount in dollars & cents (e.g., $100.52)",
              className: "col-6",
              control: control,
              disable: isChecked,
            },
            {
              title: "Routing Number *",
              field: "routingNumber",
              type: "number",
              className: "col-6",
              disablePaste: true,
            },
            // {
            //   title: "Payee’s Name:",
            //   field: "PayeesName",
            //   type: "text",
            //   className: "col-12",
            // },
            // {
            //   title: "C/O:",
            //   field: "CareOf",
            //   type: "text",
            //   className: "col-12",
            // },
            {
              title: "Your Street Address as on your Bank Account",
              // field: "PayeesAddressLine1",
              field: "address",
              type: "text",
              className: "col-12",
            },
            {
              title: "Your City, State, Zip as on your Bank Account",
              // field: "PayeesAddressLine2",
              field: "cityStateZip",
              type: "text",
              className: "col-12",
            },
            {
              title: "Comments/Instructions:",
              field: "memo",
              type: "text",
              className: "col-12",
              disable: true,
            },
          ],
        },
      ],
    },
  ];
};
